import { FC } from 'react'
import { konnectStrings } from 'common/strings/konnect-strings'
import HeadingWithSpan from 'components/HeadingWithSpan'

type RiskManagedMailProcessingType = {}

const RiskManagedMailProcessing: FC<RiskManagedMailProcessingType> = ({}) => {
  return (
    <>
      <div className='row px-2 position-relative mb-lg-9 mb-2'>
        <div className='col-md-8 ps-lg-2 pe-6 pe-md-18 px-0'>
          <p className={'fs-fluid-24-32 text-semibold mb-lg-3 mb-2'}>
            {konnectStrings.ourClientsPartnerships}
          </p>
          <HeadingWithSpan
            size={1}
            className={'h1--extra-small-on-mobile text-semibold'}
          >
            {konnectStrings.ourClientsPartnershipsTitle}
          </HeadingWithSpan>
        </div>
      </div>
      <p
        className={'h4 h4--ls-mobile-large h4--ls text-bold mb-lg-3 mb-2'}
        dangerouslySetInnerHTML={{
          __html: konnectStrings.authorOfQuote,
        }}
      />
      <blockquote
        className={'quote color-grey5 fw-semibold fst-italic pe-md-28'}
      >
        {konnectStrings.quote}
      </blockquote>
      <cite className={'h4 h4--ls-mobile-large h4--ls text-bold fst-normal'}>
        {konnectStrings.sourceOfQuote}
      </cite>
    </>
  )
}

export default RiskManagedMailProcessing
